// Messages for operator/settings/Taxonomies (auto-merged into the i18n catalog by lib/i18n.ts).
export const en = {
  'operator.taxonomies.head': 'Taxonomies — Operator',
  'operator.taxonomies.title': 'Taxonomies & tags',
  'operator.taxonomies.desc': 'Operator-defined term sets attachable to records.',
  'operator.taxonomies.apply_hint':
    'Apply these tags from a shipment, customer or carrier detail page (the “Add tag” chip under the title).',
  'operator.taxonomies.add_term': 'Add term…',
  'operator.taxonomies.add': 'Add',
  'operator.taxonomies.name': 'Name',
  'operator.taxonomies.key': 'Key',
  'operator.taxonomies.key_error': 'Key {error}',
  'operator.taxonomies.add_taxonomy': 'Add taxonomy',
  'operator.taxonomies.delete': 'Delete',
  'operator.taxonomies.no_terms': 'No terms yet.',
  'operator.taxonomies.empty': 'No taxonomies defined yet.',
}

export const zhTW = {
  'operator.taxonomies.head': '分類 — 操作員',
  'operator.taxonomies.title': '分類與標籤',
  'operator.taxonomies.desc': '操作員定義、可附加至紀錄的術語集。',
  'operator.taxonomies.apply_hint':
    '可於貨件、客戶或承運商的詳細頁面套用這些標籤（標題下方的「新增標籤」）。',
  'operator.taxonomies.add_term': '新增術語…',
  'operator.taxonomies.add': '新增',
  'operator.taxonomies.name': '名稱',
  'operator.taxonomies.key': '鍵',
  'operator.taxonomies.key_error': '鍵{error}',
  'operator.taxonomies.add_taxonomy': '新增分類',
  'operator.taxonomies.delete': '刪除',
  'operator.taxonomies.no_terms': '尚無術語。',
  'operator.taxonomies.empty': '尚未定義分類。',
}
